import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';

import { roundDecimal } from '#root/utils';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from '#root/components/ui';
import styles from './priceDialog.module.scss';

interface PriceDialogProps {
  open: boolean;
  onClose: () => void;
  deal: any;
}

const PriceDialog = (props: PriceDialogProps) => {
  const { open = false, onClose, deal } = props;
  const comBruta = deal.comtot ? Number(deal.comtot) : 0;
  const matchFee = deal.guvery_match_fee ? Number(deal.guvery_match_fee) : 0;
  const hasMatchFee = matchFee > 0;
  const comNeta = comBruta - matchFee;

  return (
    <Modal open={open} onClose={onClose}>
      <ModalHeader>
        <ModalTitle>Detalle del total</ModalTitle>
      </ModalHeader>
      <ModalBody flush>
        <TableContainer>
          <Table className={styles.table}>
            <TableHead className={styles.header}>
              <TableRow>
                <TableCell>Producto</TableCell>
                <TableCell>Precio Real</TableCell>
                <TableCell>Comisión</TableCell>
                <TableCell>Total</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {deal?.deal_orders?.map((order, index) => {
                const orderCom = hasMatchFee && comBruta > 0
                  ? order.com - (matchFee * order.com / comBruta)
                  : order.com;
                return (
                  <TableRow key={index}>
                    <TableCell>
                      <span className={styles.name}>
                        <span>{`${order.can} x`}</span>
                        <a
                          className={styles.link}
                          href={order.url}
                          target="_blank"
                          rel="noopener noreferrer">
                          <span>{order.fixed_url}</span>
                        </a>
                      </span>
                    </TableCell>
                    <TableCell>$ {order.pre ? roundDecimal(order.pre) : '---'}</TableCell>
                    <TableCell>$ {order.com ? roundDecimal(orderCom) : '---'}</TableCell>
                    <TableCell>
                      $ {order.pre ? roundDecimal(order.pre + orderCom) : '---'}
                    </TableCell>
                  </TableRow>
                );
              })}
              <TableRow>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell>
                  <span className={styles.total}>Total</span>
                </TableCell>
                <TableCell>
                  <span className={styles.total}>$ {roundDecimal(deal.total_traveler)}</span>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        {hasMatchFee && (
          <div className={styles.breakdown}>
            <span className={styles.breakdownNote}>
              Match Fee ya descontado. Comisión neta: <strong>$ {roundDecimal(comNeta)}</strong>.
            </span>
          </div>
        )}
      </ModalBody>
      <ModalFooter>
        <Button variant="outline" onClick={onClose}>
          Cerrar
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default PriceDialog;
